import styled from 'styled-components'

export const BrandWrapper = styled.div`
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  flex-shrink: 0;
  position: relative;
  transition: all 100ms ease;
`

export const BrandLink = styled.a`
  display: block;
  width: 100%;
  height: 100%;

  svg {
    width: 100%;
    height: 100%;
  }
`
